
import { useState, useEffect } from 'react';

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const scrollToSection = (id: string) => {
    setMenuOpen(false);
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 300);
  };

  const navItems = [
    { label: 'Conceito', id: 'conceito' },
    { label: 'Quem Somos', id: 'quem-somos' },
    { label: 'Serviços', id: 'servicos' },
    { label: 'Projetos', id: 'projetos' },
    { label: 'Contato', id: 'contato' },
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled || menuOpen ? 'bg-dark/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-20">
          <div className="flex items-center justify-between h-16 sm:h-20">
            <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
              <img 
                src="https://static.readdy.ai/image/ddc6dbc53596691e38d04fbd711f3d87/cec43e6d74cb0ebaf8d97e3cce2e1f27.png" 
                alt="Mansa Musa JH" 
                className="h-10 sm:h-12 w-auto"
              />
            </div>

            <div className="hidden md:flex items-center gap-8">
              {navItems.map((item, index) => (
                <div key={item.id} className="flex items-center gap-8">
                  {index > 0 && <div className="w-px h-4 bg-gold/30"></div>}
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="text-xs uppercase tracking-widest text-gray-300 hover:text-gold transition-colors duration-300 whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </button>
                </div>
              ))}
            </div>

            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="md:hidden flex flex-col items-center justify-center w-10 h-10 gap-1.5 cursor-pointer"
              aria-label="Menu"
            >
              <span className={`block w-6 h-0.5 bg-gold transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
              <span className={`block w-6 h-0.5 bg-gold transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block w-6 h-0.5 bg-gold transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
            </button>
          </div>
        </div>
      </nav>

      <div
        className={`fixed inset-0 z-40 bg-dark/98 backdrop-blur-lg transition-all duration-400 md:hidden flex flex-col items-center justify-center gap-6 ${
          menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        style={{ paddingTop: '5rem' }}
      >
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => scrollToSection(item.id)}
            className="text-lg uppercase tracking-widest text-gray-300 hover:text-gold transition-colors duration-300 cursor-pointer py-2"
          >
            {item.label}
          </button>
        ))}
        <div className="w-12 h-px bg-gold/40 mt-2"></div>
        <p className="text-xs text-gray-500 uppercase tracking-widest mt-2">Mansa Musa JH</p>
      </div>
    </>
  );
}
